import React from 'react';

import { PrismicRichText } from '@prismicio/react';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import { getMediaCdnUrl } from 'global/prismicUtils';
import useWindowSize from 'global/utils/useWindowSize';
import BannerButton from 'slices/Banner/BannerButton';
import { FlexColumn } from 'styles/layouts';

import { ImageContainer, TextWrapper, Wrapper, ButtonsWrapper } from './styles';

const ImageElement = ({ slice }) => (
  <ImageContainer>
    {slice.primary.image?.url && !slice.primary.video?.url && (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        alt={slice.primary.image.alt}
        src={getMediaCdnUrl(slice.primary.image.url)}
      />
    )}
    {slice.primary.video?.url && (
      <video autoPlay loop muted playsInline controls={false}>
        <source src={getMediaCdnUrl(slice.primary.video.url)} />
      </video>
    )}
  </ImageContainer>
);

const ImageSection = ({ slice }) => {
  const { isMobile } = useWindowSize();
  const imageOnTheRight = slice.primary.imagePosition === 'right';
  const hasButtons = !!slice.items?.find((button) => button.label);

  return (
    <ContentWrapper
      background="white"
      className="image-section"
      customWidth="1115px"
    >
      <Wrapper imageOnTheRight={imageOnTheRight}>
        {(!imageOnTheRight || isMobile) && <ImageElement slice={slice} />}
        <FlexColumn>
          <TextWrapper as="div" hasButtons={hasButtons}>
            <PrismicRichText field={slice.primary.text} />
          </TextWrapper>
          {hasButtons && (
            <ButtonsWrapper>
              {slice.items.map((item, index) => (
                <BannerButton key={index} {...item} />
              ))}
            </ButtonsWrapper>
          )}
        </FlexColumn>
        {imageOnTheRight && !isMobile && <ImageElement slice={slice} />}
      </Wrapper>
    </ContentWrapper>
  );
};

export default ImageSection;
